import { InputType } from '@workflow-admin/shared/workflow/utils/workflow';

export const inputTypeLabel = {
  [InputType.QuestionSet]: "Vragenset",
  [InputType.Question]: "Vraag",
  [InputType.Action]: "Actie",
  [InputType.Workflow]: "Workflow",
}
